import { CopyIcon } from "@chakra-ui/icons";
import {
  Badge, Box, Button as CButton, Image, Text, useClipboard, useToast, VStack
} from "@chakra-ui/react";
import Button from "components/Button/Button";
import useDebounce from "hooks/useDebounce";
import { useEffect, useState } from "react";

const TwoFaGenerated = ({generate2faData, onSafe}) => {
  const toast = useToast();
  const redebounce = useDebounce();
  const [readyToProceed, setReadyToProceed] = useState(false);

  const { hasCopied, onCopy } = useClipboard(generate2faData?.secret ?? "");

  useEffect(() => {
    if (hasCopied) {
      toast({
        title: "Copied!",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [toast, hasCopied]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (generate2faData) {
      console.log("GENERATE NEW 2FA Data", generate2faData);
      toast({
        position: "bottom-right",
        title: "Success",
        description: "New 2FA activated successfully",
        status: "success",
        duration: 6000,
        isClosable: true,
      });

      redebounce(() => toast({
        position: "bottom-right",
        title: "Success",
        description: "2FA is now enabled on your account 🥳👍",
        status: "success",
        duration: 9000,
        isClosable: true,
      }), "toast-msg2-2fa", 3000)();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    toast,
    generate2faData,
  ]);

  useEffect(() => {
    redebounce(setReadyToProceed(true),"readty-to-proceed", 3000)();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box as="form" mt="50px" onSubmit={handleSubmit}>
      <VStack>
        {generate2faData && (
          <VStack>
            <Image
              boxSize="180px"
              src={generate2faData?.qrCodeLink}
              alt="2fa qr code"
            />
            <CButton
              size="xs"
              maxW="md"
              overflow="hidden"
              whiteSpace="wrap"
              textOverflow="ellipsis"
              onClick={onCopy}
              as={Badge}
              colorScheme="green"
              rightIcon={
                <Box
                  bg="white"
                  p="4px"
                  borderRadius="4px"
                  pos="relative"
                  right="-6px"
                >
                  <CopyIcon />
                </Box>
              }
              bg="green.100"
              color="black"
              _hover={{ bg: "green.200" }}
            >
              SECRET:{"  "}
              <Text ml="4px" maxW="220px" color="green.500">
                {generate2faData?.secret}
              </Text>
            </CButton>
          </VStack>
        )}

        {generate2faData && readyToProceed && (
          <Button
            minW="100%"
            disabled={!readyToProceed}
            onClick={() => {
              onSafe && onSafe()
            }}
            minH="56px"
            fontWeight="normal"
            mt="30px !important"
          >
            I have kept my secret safely, let's continue
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default TwoFaGenerated;
